import {
    RESET_ADITIONAL_FIELDS,
    ADITIONAL_FIELDS_ERROR,
    GET_ADITIONAL_FIELDS,
    SET_ADITIONAL_FIELDS,
    SET_CURRENT_CHAT_DATA,
    SAVE_ADITIONAL_FIELDS,
    SAVE_ADITIONAL_FIELDS_SUCCESS,
    RESET_API_ADITIONAL_FIELDS,
  } from "./actionTypes";
  
  export const resetAditionalFields = (reset) => {
    return {
      type: RESET_ADITIONAL_FIELDS,
      payload: reset,
    };
  };
  export const resetApiAditionalFields = () => {
    return {
      type: RESET_API_ADITIONAL_FIELDS,
      payload: {},
    };
  };
  export const aditionalFieldsError = (error) => {
    return {
      type: ADITIONAL_FIELDS_ERROR,
      payload: error,
    };
  };
  
  export const getAditionalFields = (chatId) => {
    return {
      type: GET_ADITIONAL_FIELDS,
      payload: chatId,
    };
  };
  export const setAditionalFields = (chatId, data) => {   
    return {
      type: SET_ADITIONAL_FIELDS,
      payload: { chatId, data },
    };
  };
  export const setCurrentChatData = (conversationId, tabId, consumerId) => {
    return {
      type: SET_CURRENT_CHAT_DATA,
      payload: { conversationId, tabId, consumerId },
    };
  };

  export const saveAditionalFields = (chatId, data) => {
    return {
      type: SAVE_ADITIONAL_FIELDS,
      payload: { chatId, data },
    };
  };

  export const setAditionalFieldsSuccess = (chatId, data) => {   
    return {
      type: SAVE_ADITIONAL_FIELDS_SUCCESS,
      payload: { chatId, data },
    };
  };
  